import { useAuthStore } from "../store/authStore.js";

/**
 * True when the active workspace is a root (no parent). Billing and plan
 * upgrades live only on root workspaces — child workspaces can't upgrade
 * themselves (their plans are managed from the root's billing screen), so
 * upgrade CTAs are hidden when this is false.
 */
export function useIsRoot() {
  return useAuthStore((s) => s.workspace?.parent_id == null);
}
